@if (errorMessage()) {
  <div class="errorMessage">
    {{errorMessage()}}
  </div>
}
@if (isClosed) {
  <div class="task-closed-error">
    <h2>This task has already been closed</h2>
  </div>
}
@if (taskResponse) {
  <div class="content">
    <div class="input-row">
      <div class="instruction-label">
        Please enter a shipping charge and ship to state for project {{ entity?.projectName }}
      </div>
    </div>
    <div class="input-row">
      <mat-form-field class="input-field" subscriptSizing="dynamic">
        <mat-label>Shipping Charge</mat-label>
        <input matInput [(ngModel)]="taskResponse.shippingCharge" type="number" (keyup.enter)="closeTask()" />
      </mat-form-field>
    </div>
    <div class="input-row">
      <mat-form-field class="input-field" subscriptSizing="dynamic">
        <mat-label>Ship to State</mat-label>
        <mat-select [(ngModel)]="taskResponse.stateCode">
          @for (state of states; track state) {
            <mat-option [value]="state.code">{{state.description}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="button-row">
      <button matButton="elevated" class="action-button warn-button" (click)="backToHome()">
        Cancel
      </button>
      <button matButton="elevated" class="action-button primary-button" [disabled]="isBusy() || !isValidResponse()"
        (click)="closeTask()">
        Save
      </button>
    </div>
  </div>
}
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
